export default __webpack_public_path__ + "static/media/fencing.4e57414e.jpg";